class Toggle {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
        this.run()
    }
    run() {
        document.querySelectorAll('[data-toggle]').forEach((el) => {
            new ToggleItem(this, el)
        })
    }
}

class ToggleItem {
    constructor(parent, el) {
        this.parent = parent
        this.el = el
        this.id = el.dataset.toggle;
        this.class = el.dataset.toggleClass || 'toogle--is-open'
        this.run()
    }
    run() {
        this.el.addEventListener('click', (ev) => {
            ev.stopPropagation()
        })
        document.querySelectorAll('[data-toggle-toggle="' + this.id  + '"]').forEach((el) => this.initAction(el, 'toggle'))
        document.querySelectorAll('[data-toggle-open="' + this.id  + '"]').forEach((el) => this.initAction(el, 'open'))
        document.querySelectorAll('[data-toggle-close="' + this.id  + '"]').forEach((el) => this.initAction(el, 'close'))
    }
    initAction(elAction, actionType) {
        elAction.addEventListener('click', (ev) => {
            ev.stopPropagation()
            if ('open' === actionType) {
                this.el.classList.add(this.class)
            } else if ('close' === actionType) {
                this.el.classList.remove(this.class)
            } else {
                this.el.classList.toggle(this.class)
            }
        })
    }
}

export default Toggle